var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_21839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0031 39.7562C9.13889 39.7562 0.25 30.8673 0.25 20.0031C0.25 9.13889 9.13889 0.25 20.0031 0.25C30.8673 0.25 39.7562 9.13889 39.7562 20.0031C39.7562 30.8673 30.8673 39.7562 20.0031 39.7562ZM20.0031 3C10.9496 3 2.5 10.9465 2.5 20C2.5 29.0535 10.9496 37.5 20.0031 37.5C29.0566 37.5 37 29.0566 37 20.0031C37 10.9496 29.0566 3 20.0031 3Z",
    fill: "#29CC8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3578 26.582C17.864 26.582 17.5348 26.4174 17.2055 26.0882L12.2673 21.1499C11.6088 20.4915 11.6088 19.5038 12.2673 18.8454C12.9257 18.187 13.9134 18.187 14.5718 18.8454L19.5101 23.7837C20.1685 24.4421 20.1685 25.4298 19.5101 26.0882C19.1808 26.4174 18.8516 26.582 18.3578 26.582Z",
    fill: "#29CC8B",
    stroke: "#29CC8B",
    strokeWidth: 0.533333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.357 26.5828C17.8632 26.5828 17.534 26.4182 17.2048 26.089C16.5463 25.4305 16.5463 24.4429 17.2048 23.7844L27.0813 13.9079C27.7397 13.2495 28.7274 13.2495 29.3858 13.9079C30.0443 14.5663 30.0443 15.554 29.3858 16.2124L19.5093 26.089C19.1801 26.4182 18.8509 26.5828 18.357 26.5828Z",
    fill: "#29CC8B",
    stroke: "#29CC8B",
    strokeWidth: 0.533333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_21839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/Approve.62ace5ee279b3dce2b465af68cf5a594.svg";
export { ForwardRef as ReactComponent };